<div class="sum-items-container">

    <div class="sum-selection">
        <span class="sum-icon">∑ (</span>

        <div class="custom-dropdown" data-testid="calculation-items-dropdown" (click)="toggleDropdown()">
            <span *ngIf="selectedItems.length === 0">{{
                'aumico_notes_super_table_select_summation_columns_label' | i18next
            }}</span>
            <span *ngIf="selectedItems.length > 0">{{ selectedItems.length }} Items Selected</span>
            <span class="ham-icon">
                <i class="chevron-down-icon"></i>
            </span>
        </div>

        <span class="sum-equals"> )</span>
    </div>

    <div *ngIf="dropdownOpen" class="dropdown-options">
        <div *ngFor="let item of selectionOptions" class="dropdown-item" data-testid="calculation-item" (click)="onSelectItem(item)">
            <span class="selection-col caption">
                <!-- Selection Checkbox -->
                <span hamCheckbox [checked]="isSelected(item)" (change)="onSelectItem(item)"></span>

                <span
                    class="text"
                    data-testid="calculation-item-label"
                    [hamTooltip]="item.caption"
                    [tooltipOnlyWhenTruncated]="true"
                    [tooltipAboveModals]="true"
                >
                    {{ item.caption }}
                </span>
            </span>
            <span class="selection-col current-year" data-testid="calculation-item-current-value">{{ item.currentValue | finNumber }}</span>
            <span class="selection-col previous-year">{{ item.previousValue | finNumber }}</span>
        </div>
    </div>

    <div *ngIf="!dropdownOpen" class="selected-items">
        <span *ngFor="let item of selectedItems" class="chip">
            {{ item.caption }} <span class="remove-icon" (click)="removeItem(item)">×</span>
        </span>
    </div>
</div>
